import { useRef, useReducer } from 'react'
import Dropzone, { IDropzoneProps } from 'react-dropzone-uploader'
import { useTranslation } from 'react-i18next'
import { fileUploadAPI } from '../../shared/api/FileUploadAPI'
import { ResponseMessage } from '../../shared/model/models'
import FsAlert, { FsAlertRef } from '../common/atoms/Alert'
import { ptAPI } from '../../shared/api/PTAPI'

interface PtImportProps {
  onSuccess?: () => void
  onError?: () => void
}

const PtImport = (props: PtImportProps) => {
  const { t } = useTranslation()
  const { onSuccess, onError } = props
  const alertRef = useRef<FsAlertRef>(null)
  const [, forceUpdate] = useReducer(x => x + 1, 0)

  const handleSubmit: IDropzoneProps['onSubmit'] = (files, allFiles) => {
    const { file } = allFiles[0]
    ptAPI
      .importFile(file)
      .then((res) => {
        if (res === 204) {
          alertRef.current?.openAlert({
            status: res,
            severity: 'success',
            message: t('file.upload.success'),
          } as ResponseMessage)
          onSuccess?.()
        }
        if (res === 200) {
          alertRef.current?.openAlert({
            status: res,
            severity: 'success',
            message: t('file.upload.exists'),
          } as ResponseMessage)
          onSuccess?.()
        }
      })
      .catch((err) => {
        alertRef.current?.openAlert({
          status: err,
          severity: 'error',
          message: t('file.upload.error'),
        } as ResponseMessage)
        onError?.()
      })
    allFiles.forEach((f) => f.remove())
  }

  return (
    <div>
      <Dropzone
        onSubmit={handleSubmit}
        accept="text/csv,.csv"
        styles={{
          dropzone: {
            minHeight: 200,
            maxHeight: 250,
            border: 'dashed 2px #b0b0b0',
          },
          inputLabel: { padding: 25 },
        }}
        submitButtonContent={t('file.upload.submit')}
        maxFiles={1}
        multiple={false}
        inputContent={t('file.drag.drop')}
        onChangeStatus={(_, status) => {
          if (status === 'rejected_file_type') {
            alertRef.current?.openAlert({
              message: t('file.upload.toobig'),
              severity: 'error',
            })
          } else {
            forceUpdate()
          }
        }}
      />
      <FsAlert ref={alertRef} />
    </div>
  )
}

export default PtImport
